import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import reportWebVitals from './reportWebVitals';
import { appService } from './services/appService';
import { consoleCaptureService } from './services/consoleCapture';
import { urlOptions } from './utils/urlOptions';
import { betterStackLogger } from './services/betterStackLogger';
import { appConfig } from './config';

// Initialize BetterStack logging as early as possible
betterStackLogger.init({
  sourceToken: appConfig.betterStackSourceToken,
  appName: 'werewolf-app',
  logLevel: appConfig.betterStackLogLevel as 'debug' | 'info' | 'warn' | 'error',
});

// Initialize console capture before anything else
if (urlOptions.debug) consoleCaptureService.initialize();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

appService.initializeAsync();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();